import { legacyApiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "./BaseResource";
class ApplicationFormalitiesResource extends BaseCamelCasedResource {
    pk() {
        return `${this.applicationNumber}::${this.key}`;
    }
}
ApplicationFormalitiesResource.urlRoot = legacyApiResourceUrl("FormalitiesCheck/GetFormalitiesCheckpoints");
export { ApplicationFormalitiesResource };
//# sourceMappingURL=ApplicationFormalitiesResource.js.map